var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSIconMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17939 10.1837C9.60186 10.1837 9.94434 9.84124 9.94434 9.41877C9.94434 8.99629 9.60186 8.65381 9.17939 8.65381C8.75691 8.65381 8.41443 8.99629 8.41443 9.41877C8.41443 9.84124 8.75691 10.1837 9.17939 10.1837Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17939 4.82899C9.60186 4.82899 9.94434 4.4865 9.94434 4.06403C9.94434 3.64156 9.60186 3.29907 9.17939 3.29907C8.75691 3.29907 8.41443 3.64156 8.41443 4.06403C8.41443 4.4865 8.75691 4.82899 9.17939 4.82899Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17939 15.5384C9.60186 15.5384 9.94434 15.1959 9.94434 14.7734C9.94434 14.351 9.60186 14.0085 9.17939 14.0085C8.75691 14.0085 8.41443 14.351 8.41443 14.7734C8.41443 15.1959 8.75691 15.5384 9.17939 15.5384Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSIconMoreVertical);
export default __webpack_public_path__ + "static/media/s-icon-more-vertical.23d95a0f75d24dd8eb3d80ae867f8bc9.svg";
export { ForwardRef as ReactComponent };